export default __webpack_public_path__ + "static/media/logo-invision.78bd5901.svg";